import MenuComponent from '@/components/MenuComponent'

import { OubliPassword } from '@/models/credentialssearch.model'

export default {
  components: {
    MenuComponent
  },

  data () {
    return {
      oubliPassword: new OubliPassword(),
      showForm: true,
      isFormCompleted: false,
      isResultOK: false,
      isPasswordSent: false,
      isPasswordOngoing: false,
      validationMessage: [],
      errorMessage: ''
    }
  },

  methods: {
    recherchePassword () {
      this.showForm = false
      this.$store.dispatch('credentials/searchPassword', this.oubliPassword).then(
        reponse => {
          this.isResultOK = true
          this.isPasswordSent = true
        },
        error => {
          if (error.response.data === 'USER_RESET_PASSWORD_ONGOING') {
            this.isPasswordOngoing = true
          } else {
            this.errorMessage = error.response
          }
        }
      )
    },

    validationFormulaire () {
      this.validationMessage = []
      if (!this.oubliPassword.login || this.oubliPassword.login === '') {
        this.validationMessage[0] = 'L\'identifiant doit être renseigné'
      }
      if (!this.oubliPassword.lastName || this.oubliPassword.lastName === '') {
        this.validationMessage[1] = 'Le nom doit être renseigné'
      }
      if (!this.oubliPassword.firstName || this.oubliPassword.firstName === '') {
        this.validationMessage[2] = 'Le prénom doit être renseigné'
      }
      if (!this.oubliPassword.zipCode || this.oubliPassword.zipCode === '') {
        this.validationMessage[3] = 'Le code postal doit être renseigné'
      }
      if (this.validationMessage.length === 0) {
        this.isFormCompleted = true
        this.recherchePassword()
      }
    }
  }
}
